import React, { useState, useEffect } from 'react';

const TextArea = ({ value, onChange, placeholder, className }) => {
  const [isMobile, setIsMobile] = useState(false);
  
  // Detect mobile devices
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Initial check
    checkMobile();
    
    // Add resize listener
    window.addEventListener('resize', checkMobile);
    
    // Clean up
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={`long-answer-input ${className || ''} ${isMobile ? 'mobile-textarea' : ''}`}
      rows={isMobile ? 3 : 5}
    />
  );
};

export default TextArea;